import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import { Toast } from '../configs/toast';
import { retry, catchError } from 'rxjs/operators';
import { Observable, firstValueFrom, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

declare var $:any

@Injectable({
    providedIn: 'root'
})
export class RestService {
    open() {
      throw new Error('Method not implemented.');
    }
    url:string = environment.url
    loading:boolean = true
    constructor(
        private http:HttpClient,
    ){

    }

    clearSession = () => {
    };

    setHeaders = ( file = false):HttpHeaders => {
        let header:any = {
            // Accept: 'application/json',
            // 'Content-Type': 'application/json',
            'Cache-Control' : 'no-cache',
            'Authorization' : `Bearer ${localStorage.getItem('session')}`,
        };
        
        // Agregar CpnyID si está disponible en localStorage
        const selectedCpnyID = localStorage.getItem('selectedCpnyID');
        if (selectedCpnyID) {
            header['CpnyID'] = selectedCpnyID;
        }
        
        return new HttpHeaders(header);
    }

    async getFirstValue(rest:Observable<any>):Promise<any>{
        try {
            return firstValueFrom(rest)
        } catch (error) {
            if (error instanceof HttpErrorResponse) {
                console.log(error)
                $(document).Toasts('create', {
                    title: `${error.status} - ${error.statusText}`,
                    // subtitle:
                    body: error.message,
                    position: 'bottomRight',
                    class: 'bg-danger'
                })
            }
        }
    }

    post = ( url:string, body:any = {}, headers:any = {}):Observable<any> =>{
        return this.http.post(`${this.url}${url}`,body,{
            headers: this.setHeaders()
        })
    }

    patch = ( url:string, body:any = {}, headers:any = {}):Observable<any> =>{
        return this.http.patch(`${this.url}${url}`,body,{
            headers: this.setHeaders()
        })
    }

    delete = ( url:string, headers:any = {}) =>{
        return this.http.delete(`${this.url}${url}`,{
            headers: this.setHeaders()
        })
    }

    get = ( url:string, params = {}  ):Observable<any> => {
        return this.http.get( `${this.url}${url}`, {
            headers: this.setHeaders(),
            params,
        } )
    }

    getFile = (url:string, params = {}):Observable<any> => {
        return this.http.get( `${this.url}${url}`, {
            headers: this.setHeaders(),
            responseType: 'arraybuffer',
            params,
        } )
    }
    

     /**
   * Method is use to download file.
   * @param data - Array Buffer data
   * @param type - type of the document.
   */
  downLoadFile(name:string, type: any, data: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url,"Libro ingreso y egreso");
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      Toast.fire('Please disable your Pop-up blocker and try again','','info')
    }
  }

    saveFile (name:string, type:any, data:any) { 
        // if (data != null && navigator.msSaveBlob) 
        //  return navigator.msSaveBlob(new Blob([data], { type: type }), name); 
        let a = $("<a style='display: none;'/>"); 
        let url = window.URL.createObjectURL(new Blob([data], {type: type})); 
        a.attr("href", url); 
        a.attr("download", name); 
        $("body").append(a); 
        a[0].click(); 
        window.URL.revokeObjectURL(url); 
        a.remove(); 
    } 

    errorHandl(error:HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Get client-side error
          errorMessage = error.error.message;
        } else {
          // Get server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(() => {
          return errorMessage;
        });
      }
}